  import React, { useEffect, useState, memo, Fragment } from "react";
  import { Container, Row, Col, Card } from "react-bootstrap";
  import AsyncStorage from '@react-native-async-storage/async-storage';
  import { FaUser, FaUsers, FaClock, FaStopwatch, FaHourglassHalf, FaPercentage, FaDatabase, FaPhone, FaPhoneAlt, FaPhoneVolume, FaPhoneSlash, FaCog, FaPhoneSquareAlt } from 'react-icons/fa';
  import { getApiCall } from '../../service/httpCall';
  import { API_AGENTS_LIST,API_AGENT_SCHEDULE, API_ALL_INCOMING_REPORT, API_DASHBOARD_INCOMING_SUMMARY, API_DASHBOARD_OUTGOING_CALLS_SUMMARY, API_DASHBOARD_STATS } from '../../service/url';
  import "bootstrap/dist/css/bootstrap.min.css";
  import { TelephoneFill } from "react-bootstrap-icons";
  import { ROUTES } from "../../utilities/constant";
  import { useNavigate } from "react-router-dom";
  import "../../assets/custom/css/dash.css"
  // AOS
  // import AOS from "aos";
  // import "../../../node_modules/aos/dist/aos";
  // import "../../../node_modules/aos/dist/aos.css";

  import SwiperCore, { Navigation } from "swiper";
  import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
  import CTIAgentUI from "./CTIAgentUI";

  // Import Swiper styles
  import "swiper/swiper-bundle.min.css";
  // import 'swiper/components/navigation/navigation.scss';

  // Redux Selector / Action
  import { useSelector } from "react-redux";

  // Import selectors & action from setting store
  import * as SettingSelector from "../../store/setting/selectors";

  import { USER_ROLES } from '../../utilities/constant';
  import Chart from "react-apexcharts"
  import { toast } from "react-toastify";
  import DashboardCampaignDetails from "./dashboard-campaign-details";
  import PendingPromptsTable from "./pending-prompts";
  import UserWiseCampaignSummary from "./user-wise-campaign-summary";
  import TodayRunningCampaigns from "./today-running-campaigns";
  import DashboardUsersCampCount from "./dashboard-users-camp-count";
  import useSocket from "../../hooks/useSocket";
  import SystemMonitor from "./system-monitor";
  import AgentStatusDistribution from "./agent-status-distribution";
  import DashboardCallsCharts from "./dashboard-calls-charts";
  import AgentBreakExceededList from "./agent-break-exceeded/agent_break_exceeded_list";

  // install Swiper modules
  SwiperCore.use([Navigation]);


  const Index = memo((props) => {
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isReseller, setIsReseller] = useState(false);
    const [graph, setGraph] = useState([]);
    const [isCompanyAdmin, setCompanyAdmin] = useState(false);
    const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
    const [isCallCenterAgent, setCallCenterAgent] = useState(false);
    const [agentId, setAgentId] = useState(null);
    const [agentGroups, setAgentGroups] = useState([]); // list of groups for that agent
    const [showQueueTooltip, setShowQueueTooltip] = useState(false); // hover state
    const [queuePage, setQueuePage] = useState(0);
    const [dashboardStats, setDashboardStats] = useState(null);
    const [loggedInUserRole, setLoggedInUserRole] = useState(null);
    const [loggedInAgentId, setLoggedInAgentId] = useState(null);
    const pageSize = 2;
    const totalPages = Math.ceil(agentGroups.length / pageSize);


    const [IncomingstartDate, setIncomingStartDate] = useState(null)
    const [IncomingendDate, setIncomingEndDate] = useState(null)

    const [startDate, setStartDate] = useState(() => {
      const x = new Date();
      x.setHours(0, 0, 0, 0);
      return x;
    });
    const [endDate, setEndDate] = useState(() => {
      const x = new Date();
      x.setHours(0, 0, 0, 0);
      return x;
    });

    const [AgentStartDate, setAgentStartDate] = useState(null)
    const [AgentEndDate, setAgentEndDate] = useState(null)

    const [OutgoingstartDate, setOutgoingStartDate] = useState(null)
    const [OutgoingendDate, setOutgoingEndDate] = useState(null)

    const [agentDataObject, setAgentDataObject] = useState({
      total_agent: 0,
      logged_in_agent: 0,
      agent_on_call: 0
    });
    const [incomingSummaryData, setIncomingSummaryData] = useState({
      dialed_call: 0,
      answered_call: 0,
    });

    const [InboundReportData, setInboundReportData] = useState({
      abandoned_calls: 0,
    })

    const [outgoingCallsData, setOutgoingCallsData] = useState({
      total_calls: 0,
      dialed_call: 0,
      answered_call: 0,
    })

    const [shake, setShake] = useState(false);
    const navigate = useNavigate();


    const handleToggleChat = () => {
      navigate(`/${ROUTES.REMARKS.REMARKS}`);
    };

    const handleToggleDisposition = () => {
      navigate(`/${ROUTES.DESPOSITION.ADD}`);
    };

    const isAgentReady =
      loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT &&
      loggedInAgentId;

    useSocket(isAgentReady ? loggedInAgentId : null)


    useEffect(() => {
      const interval = setInterval(() => {
        setShake(true);
        setTimeout(() => setShake(false), 500);
      }, 2700);
      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
  if (showQueueTooltip) setQueuePage(0);
}, [showQueueTooltip]);


const paginatedGroups = agentGroups.slice(
  queuePage * pageSize,
  queuePage * pageSize + pageSize
);

const hasPrev = queuePage > 0;
const hasNext = queuePage < totalPages - 1;


    useEffect(() => {
      async function checkUserRole() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null;
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role) {
          setLoggedInUserRole(user.role);
          setLoggedInAgentId(user?.agentData?.id);
        }
        if (user.role === USER_ROLES.SUPERADMIN) setIsSuperAdmin(true);
      }
      checkUserRole();
    }, []);



    const doughnutAgentsData = {
      labels: ["Total Agents", "Logged In Agents", "Agents On Call"],
      datasets: [
        {
          data: [(Number(agentDataObject?.total_agent) || 0), (Number(agentDataObject?.logged_in_agent) || 0), (Number(agentDataObject?.agent_on_call) || 0)],
          backgroundColor: ["#2ebf3f", "#eb173b", "#1761ebff"],
          borderWidth: 0,
        },
      ],
    };


    const doughnutData1 = doughnutAgentsData.labels.map((label, index) => ({
      name: label,
      value: doughnutAgentsData.datasets[0].data[index],
    }));

    const doughnutIncomingData = {
      labels: ["Dialed Calls", "Answered Calls", "Abandoned Calls"],
      datasets: [
        {
          data: [(Number(incomingSummaryData.dialed_call) || 0), (Number(incomingSummaryData.answered_call) || 0), (Number(incomingSummaryData.abandoned_calls) || 0)],
          backgroundColor: ["#e45604ff", "rgba(53, 214, 220, 1)", "rgb(156, 39, 176)"],
          borderWidth: 0,
        },
      ],
    };


    const incomingData = doughnutIncomingData.labels.map((label, index) => ({
      name: label,
      value: doughnutIncomingData.datasets[0].data[index],
    }));

    const doughnutOutgoingData = {
      labels: ["Total Calls", "Dialed Calls", "Answered Calls"],
      datasets: [
        {
          data: [(Number(outgoingCallsData?.total_calls) || 0), (Number(outgoingCallsData?.dialed_call) || 0), (Number(outgoingCallsData?.answered_call) || 0)],
          backgroundColor: ["#f00054ff", "#d2cc1bff", "#28927bff"],
          borderWidth: 0,
        },
      ],
    };


    const outgoingDataDoughnut = doughnutOutgoingData.labels.map((label, index) => ({
      name: label,
      value: doughnutOutgoingData.datasets[0].data[index],
    }));

    const doughnutAgentOutgoingData = {
      labels: ["Total Calls", "Dialed Calls", "Answered Calls"],
      datasets: [
        {
          data: [(Number(outgoingCallsData?.total_calls) || 0), (Number(outgoingCallsData?.dialed_call) || 0), (Number(outgoingCallsData?.answered_call) || 0)],
          backgroundColor: ["#f00054ff", "#d2cc1bff", "#28927bff"],
          borderWidth: 0,
        },
      ],
    };

    const doughnutOptions = {
      cutout: "50%",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        font: {
            size: 24
          },
      },
    };



    const barIncomingData = {
      series: [
        {
          name: "Calls",
          data: [
            Number(incomingSummaryData.dialed_call) || 0,
            Number(incomingSummaryData.answered_call) || 0,
            Number(incomingSummaryData.abandoned_calls) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60, // pull chart up
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%", // makes bars slimmer/fatter
          },
        },
        xaxis: {
          categories: ["Dialed Calls", "Answered Calls", "Abandoned Calls"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10, // move numbers left or right
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#e45604", "#35d6dc", "#9c27b0"],
      },
    };

    const barOutgoingData = {
      series: [
        {
          name: "Calls",
          data: [
            Number(outgoingCallsData?.total_calls) || 0,
            Number(outgoingCallsData?.dialed_call) || 0,
            Number(outgoingCallsData?.answered_call) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60, // same as incoming
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%",
          },
        },
        xaxis: {
          categories: ["Total Calls", "Dialed Calls", "Answered Calls"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10, // space between numbers & grid lines
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#f00054ff", "#d2cc1bff", "#28927bff"], // from doughnutOutgoingData
      },
    };

    const barAgentsData = {
      series: [
        {
          name: "Agents",
          data: [
            Number(agentDataObject?.total_agent) || 0,
            Number(agentDataObject?.logged_in_agent) || 0,
            Number(agentDataObject?.agent_on_call) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60,
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%",
          },
        },
        xaxis: {
          categories: ["Total Agents", "Logged In Agents", "Agents On Call"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10,
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#2ebf3f", "#eb173b", "#1761ebff"], // matching doughnut chart
      },
    };



useEffect(() => {
  if (!agentId) return; 

  const fetchAgentGroups = async () => {
    try {
      const resp = await getApiCall(`${API_AGENT_SCHEDULE}/${agentId}`);
      if (
        resp
      ) {
        setAgentGroups(resp.groups);
      } else {
        setAgentGroups([]);
      }
    } catch (err) {
      console.error("Error fetching agent schedule:", err);
      setAgentGroups([]);
    }
  };

  if (!isCallCenterAgent && !agentId) {
  fetchAgentGroups();
  }
}, [agentId, isCallCenterAgent, agentId]);




    useEffect(() => {
      async function superadminCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role) {
          setLoggedInUserRole(user.role);
        }
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperAdmin(true);
        }
        if (user.role === USER_ROLES.COMPANY_ADMIN) {
          setCompanyAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
          setCallCenterAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_AGENT) {
          setCallCenterAgent(true)
          setAgentId(user.agentData?.id|| null)
        }
      }
      async function resellerCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.RESELLER) {
          setIsReseller(true);
        }
      }
      superadminCheck();
      resellerCheck();
    }, []);

    useEffect(() => {
      async function superadminCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role) {
          setLoggedInUserRole(user.role);
        }
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperAdmin(true);
        }
        if (user.role === USER_ROLES.COMPANY_ADMIN) {
          setCompanyAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
          setCallCenterAdmin(true);
        }
      }

      async function resellerCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.RESELLER) {
          setIsReseller(true);
        }
      }
      superadminCheck();
      resellerCheck();
    }, []);

    const fetchAgents = () => {
      getApiCall(API_AGENTS_LIST)
        .then((resp) => {
          // console.log('resprespresprespresp', resp)
          if (resp && Array.isArray(resp)) {
            const total_agent = resp.length;
            const logged_in_agent = resp.filter(agent => agent.login_status === "1").length;
            const agent_on_call = resp.filter(agent => agent.call_status === "1").length;
            setAgentDataObject({ total_agent, logged_in_agent, agent_on_call });
          }
        })
        .catch((error) => {
          console.log(error)
        })
    };

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const DASHBOARD_MAX_INCLUSIVE_DAYS = 180;

    const startOfDay = (d) => {
      const x = new Date(d);
      x.setHours(0, 0, 0, 0);
      return x;
    };

    const addDays = (d, n) => {
      const x = startOfDay(d);
      x.setDate(x.getDate() + n);
      return x;
    };

    const getInclusiveDayCount = (from, to) => {
      const s = startOfDay(from).getTime();
      const e = startOfDay(to).getTime();
      return Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1;
    };

    const maxSelectableDate = startOfDay(new Date());
    const minSelectableDate = addDays(maxSelectableDate, -(DASHBOARD_MAX_INCLUSIVE_DAYS - 1));

    // Per-calendar bounds so the pair is always <= 180 inclusive days (matches backend).
    // End: cannot exceed start + (180 - 1) days; Start: cannot be before end - (180 - 1) days.
    let dashboardStartCalendarMinDate = minSelectableDate;
    let dashboardStartCalendarMaxDate = maxSelectableDate;
    if (endDate) {
      const latestStartForEnd = addDays(endDate, -(DASHBOARD_MAX_INCLUSIVE_DAYS - 1));
      dashboardStartCalendarMinDate =
        latestStartForEnd.getTime() > minSelectableDate.getTime()
          ? latestStartForEnd
          : minSelectableDate;
      const endDay = startOfDay(endDate);
      dashboardStartCalendarMaxDate =
        endDay.getTime() < maxSelectableDate.getTime() ? endDay : maxSelectableDate;
    }
    if (dashboardStartCalendarMinDate.getTime() > dashboardStartCalendarMaxDate.getTime()) {
      dashboardStartCalendarMinDate = dashboardStartCalendarMaxDate;
    }

    let dashboardEndCalendarMinDate = minSelectableDate;
    let dashboardEndCalendarMaxDate = maxSelectableDate;
    if (startDate) {
      const earliestEndForStart = startOfDay(startDate);
      dashboardEndCalendarMinDate =
        earliestEndForStart.getTime() > minSelectableDate.getTime()
          ? earliestEndForStart
          : minSelectableDate;
      const maxEndForStart = addDays(startDate, DASHBOARD_MAX_INCLUSIVE_DAYS - 1);
      dashboardEndCalendarMaxDate =
        maxEndForStart.getTime() < maxSelectableDate.getTime() ? maxEndForStart : maxSelectableDate;
    }
    if (dashboardEndCalendarMinDate.getTime() > dashboardEndCalendarMaxDate.getTime()) {
      dashboardEndCalendarMinDate = dashboardEndCalendarMaxDate;
    }

    const handleDashboardStartDateChange = (e) => {
      let next = e.value ? startOfDay(e.value) : null;
      if (!next) {
        setStartDate(null);
        return;
      }
      if (next < minSelectableDate) next = minSelectableDate;
      if (next > maxSelectableDate) next = maxSelectableDate;
      setStartDate(next);
      setEndDate((prev) => {
        let end = prev ? startOfDay(prev) : next;
        let upper = addDays(next, DASHBOARD_MAX_INCLUSIVE_DAYS - 1);
        if (upper > maxSelectableDate) upper = maxSelectableDate;
        if (end < next) end = next;
        if (end > upper) end = upper;
        return end;
      });
    };

    const handleDashboardEndDateChange = (e) => {
      let next = e.value ? startOfDay(e.value) : null;
      if (!next) {
        setEndDate(null);
        return;
      }
      if (next < minSelectableDate) next = minSelectableDate;
      if (next > maxSelectableDate) next = maxSelectableDate;
      setEndDate(next);
      setStartDate((prev) => {
        let s = prev ? startOfDay(prev) : next;
        let lower = addDays(next, -(DASHBOARD_MAX_INCLUSIVE_DAYS - 1));
        if (lower < minSelectableDate) lower = minSelectableDate;
        if (s < lower) s = lower;
        if (s > next) s = next;
        return s;
      });
    };

    useEffect(() => {
      if (!startDate || !endDate) return;
      const today = startOfDay(new Date());
      let upper = addDays(startDate, DASHBOARD_MAX_INCLUSIVE_DAYS - 1);
      if (upper.getTime() > today.getTime()) upper = today;
      const e = startOfDay(endDate);
      const s = startOfDay(startDate);
      if (e.getTime() < s.getTime()) {
        setEndDate(s);
        return;
      }
      if (e.getTime() > upper.getTime()) {
        setEndDate(upper);
      }
    }, [startDate, endDate]);

    const handleAgentFilter = () => {
      if (!AgentStartDate || !AgentEndDate) {
        console.warn("Please select both start and end dates");
        return;
      }

      const formattedStart = formatDate(AgentStartDate);
      const formattedEnd = formatDate(AgentEndDate);

      const url = `${API_DASHBOARD_OUTGOING_CALLS_SUMMARY}?startDate=${formattedStart}&endDate=${formattedEnd}`;

      getApiCall(url)
        .then((resp) => {
          setOutgoingCallsData({
            total_calls: Number(resp?.total_calls) || 0,
            dialed_call: Number(resp?.dialed_calls) || 0,
            answered_call: Number(resp?.answered_calls) || 0
          });
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const handleFilter = () => {
    if (!startDate || !endDate) {
      console.warn("Please select both start and end dates");
      return;
    }

    if (startOfDay(startDate) > startOfDay(endDate)) {
      toast.error("Start date cannot be after end date.");
      return;
    }

    if (getInclusiveDayCount(startDate, endDate) > DASHBOARD_MAX_INCLUSIVE_DAYS) {
      toast.error(
        `Date range too large. Maximum allowed is ${DASHBOARD_MAX_INCLUSIVE_DAYS} calendar days (inclusive).`
      );
      return;
    }

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    // --- Incoming API ---
    const incomingUrl = `${API_DASHBOARD_INCOMING_SUMMARY}?startDate=${formattedStart}&endDate=${formattedEnd}`;
    const incomingPromise = getApiCall(incomingUrl)
      .then((resp) => {
        setIncomingSummaryData({
          dialed_call: Number(resp?.dialed_calls) || 0,
          answered_call: Number(resp?.answered_calls) || 0
        });
      });

    // --- Outgoing API ---
    const outgoingUrl = `${API_DASHBOARD_OUTGOING_CALLS_SUMMARY}?startDate=${formattedStart}&endDate=${formattedEnd}`;
    const outgoingPromise = getApiCall(outgoingUrl)
      .then((resp) => {
        setOutgoingCallsData({
          total_calls: Number(resp?.total_calls) || 0,
          dialed_call: Number(resp?.dialed_calls) || 0,
          answered_call: Number(resp?.answered_calls) || 0
        });
      });

    // Run both APIs in parallel
    Promise.all([incomingPromise, outgoingPromise])
      .catch((error) => console.error("Error fetching data:", error));
  };



    const fetchIncomingSummary = () => {
      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

      getApiCall(`${API_DASHBOARD_INCOMING_SUMMARY}?startDate=${today}&endDate=${today}`)
        .then((resp) => {
          setIncomingSummaryData({
            dialed_call: Number(resp?.dialed_calls) || 0,
            answered_call: Number(resp?.answered_calls) || 0
          });
        })
        .catch((error) => {
          console.error("Error fetching today’s data:", error);
        });
    };


    const fetchOutgoingCallsData = () => {
      const today = new Date();

      // helper to format date as YYYY-MM-DD
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const formattedStartDate = `${formatDate(today)}`;
      const formattedEndDate = `${formatDate(today)}`;

      const url = `${API_DASHBOARD_OUTGOING_CALLS_SUMMARY}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

      getApiCall(url)
        .then((resp) => {
          setOutgoingCallsData({
            total_calls: Number(resp?.total_calls) || 0,
            dialed_call: Number(resp?.dialed_calls) || 0,
            answered_call: Number(resp?.answered_calls) || 0
          });
        })
        .catch((error) => {
          console.error("Error fetching today's outgoing calls", error);
        });
    };


    const fetchIncomingReports = () => {
      const today = new Date().toISOString().split("T")[0]; // "2025-08-22"

      getApiCall(`${API_ALL_INCOMING_REPORT}/${today}/${today}`)
        .then((resp) => {
          if (resp) {
            setInboundReportData({
              abandoned_calls: resp.abandoned_calls
            });
          }
        })
        .catch((error) => {
          console.log("Error fetching Inbound Report Data", error);
        });
    };
    useEffect(() => {
      if (loggedInUserRole && !isCallCenterAgent && !agentId) {
        const timer = setTimeout(async () => {
          await fetchAgents();
          await fetchIncomingSummary();
          await fetchOutgoingCallsData();
          // await fetchIncomingReports();
        }, 3000);
        return () => clearTimeout(timer);
      }
    }, [isCallCenterAgent, agentId, loggedInUserRole]);
    // useEffect(
    //   fetchAgents,
    //   []);

    // useEffect(
    //   fetchIncomingSummary,
    //   []);

    // useEffect(
    //   fetchOutgoingCallsData,
    //   []);

    // useEffect(
    //   fetchIncomingReports,
    //   []);

    let data = [];

    let agentData = [];
    let incommingData = [];
    let outgoingData = [];
    let queueData = [];
    let othersData = [];




    if (isCallCenterAdmin || isSuperAdmin || isCompanyAdmin || isReseller) {

      agentData = [
        { title: 'Total Agents', value: agentDataObject.total_agent, icon: <FaUser />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
        { title: 'Logged-in Agents', value: agentDataObject.logged_in_agent, icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
        { title: 'Agents on Call', value: agentDataObject.agent_on_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
      ];
      incommingData = [
        { title: 'Dialed Calls', value: incomingSummaryData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: incomingSummaryData.answered_call, icon: <FaPhoneVolume />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
        { title: 'Abandoned Calls', value: incomingSummaryData.abandoned_calls, icon: <FaPhoneSlash />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/abandoned-call-bg.png)' }
      ];
      outgoingData = [
        { title: 'Total Calls', value: outgoingCallsData.total_calls, icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
        { title: 'Dialed Calls', value: outgoingCallsData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: outgoingCallsData.answered_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      ];

      queueData = [
        { title: 'AQT', value: '0', icon: <FaUsers />, bgColor: '#3f51b5', backgroundImage: 'url(/path/to/aqt-bg.png)' },
        { title: 'AHT', value: '0', icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/aht-bg.png)' },
        { title: 'ASA', value: '00:00', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/asa-bg.png)' },
        { title: 'SLA', value: '0%', icon: <FaPercentage />, bgColor: '#9c27b0', backgroundImage: 'url(/path/to/sla-bg.png)' },
        { title: 'Agent Disposed', value: '0', icon: <FaUser />, bgColor: '#4cabaf', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
        { title: 'System Disposed', value: '0', icon: <FaCog />, bgColor: '#f44336', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      ];

      othersData = [
        { title: 'Average Wrap-up', value: '00:00', icon: <FaClock />, bgColor: '#795548', backgroundImage: 'url(/path/to/avg-wrapup-bg.png)' },
        { title: 'Offered-Call', value: '0', icon: <FaPhoneAlt />, bgColor: '#ff5722', backgroundImage: 'url(/path/to/offered-call-bg.png)' },
        { title: 'Dialed Data', value: '0', icon: <FaDatabase />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/dialed-data-bg.png)' },
        { title: 'Pending Data', value: '0', icon: <FaPhoneSquareAlt />, bgColor: '#03a9f4', backgroundImage: 'url(/path/to/pending-data-bg.png)' },
        { title: 'Pending Callbacks', value: '0', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/pending-callback-bg.png)' },
        { title: 'Con.Dialed Calls', value: '0', icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/connected-dialed-call-bg.png)' },
      ];

    }
    else {
      outgoingData = [
        { title: 'Total Calls', value: outgoingCallsData.total_calls, icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
        { title: 'Dialed Calls', value: outgoingCallsData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: outgoingCallsData.answered_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      ];

      //  data = [
      //   { title: 'Total Agents', value: '0', icon: <FaUser />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
      //   { title: 'AQT', value: '0', icon: <FaUsers />, bgColor: '#3f51b5', backgroundImage: 'url(/path/to/aqt-bg.png)' },
      //   { title: 'AHT', value: '0', icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/aht-bg.png)' },
      //   { title: 'ASA', value: '00:00', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/asa-bg.png)' },
      //   { title: 'Average Wrap-up', value: '00:00', icon: <FaClock />, bgColor: '#795548', backgroundImage: 'url(/path/to/avg-wrapup-bg.png)' },
      //   { title: 'SLA', value: '0%', icon: <FaPercentage />, bgColor: '#9c27b0', backgroundImage: 'url(/path/to/sla-bg.png)' },
      //   { title: 'Total Data', value: '0', icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
      //   { title: 'Offered-Call', value: '0', icon: <FaPhoneAlt />, bgColor: '#ff5722', backgroundImage: 'url(/path/to/offered-call-bg.png)' },

      //   { title: 'Dialed Data', value: '0', icon: <FaDatabase />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/dialed-data-bg.png)' },
      //   { title: 'Pending Data', value: '0', icon: <FaPhoneSquareAlt />, bgColor: '#03a9f4', backgroundImage: 'url(/path/to/pending-data-bg.png)' },
      //   { title: 'Pending Callbacks', value: '0', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/pending-callback-bg.png)' },
      //   { title: 'Agent Disposed', value: '0', icon: <FaUser />, bgColor: '#4cabaf', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      //   { title: 'System Disposed', value: '0', icon: <FaCog />, bgColor: '#f44336', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      //   { title: 'Answered Calls', value: '00:00', icon: <FaPhone />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      //   { title: 'Abandoned Calls', value: '0', icon: <FaPhoneSlash />, bgColor: '#f44336', backgroundImage: 'url(/path/to/abandoned-call-bg.png)' },
      //   { title: 'Dialed Calls', value: '0', icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
      //   { title: 'Con.Dialed Calls', value: '0', icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/connected-dialed-call-bg.png)' },
      // ];
    }


    const filteredData = isSuperAdmin ? data : data.slice(0, data.length / 2);

    const graphData = [
      { status: 'Available', agents: agentDataObject.logged_in_agent },
      { status: 'Busy', agents: agentDataObject.agent_on_call },
      { status: 'Offline', agents: Number(agentDataObject.total_agent) - Number(agentDataObject.logged_in_agent) },
      // { status: 'Break', agents: 5 },
    ];

    const filteredGraphData = isSuperAdmin ? graphData : graphData.slice(0, 2);
    useSelector(SettingSelector.theme_color);

    const getVariableColor = () => {
      let prefix =
        getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
      if (prefix) {
        prefix = prefix.trim();
      }
      const color1 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}primary`
      );
      const color2 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}info`
      );
      const color3 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}primary-tint-20`
      );
      const color4 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}warning`
      );
      return {
        primary: color1.trim(),
        info: color2.trim(),
        warning: color4.trim(),
        primary_light: color3.trim(),
      };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
      return () => colors;
    });

    const chart1 = {
      options: {
        chart: {
          fontFamily:
            '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: false,
          },
        },
        colors: colors,
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            minWidth: 19,
            maxWidth: 19,
            style: {
              colors: "#8A92A6",
            },
            offsetX: -5,
          },
        },
        legend: {
          show: false,
        },
        xaxis: {
          labels: {
            minHeight: 22,
            maxHeight: 22,
            show: true,
            style: {
              colors: "#8A92A6",
            },
          },
          lines: {
            show: false, //or just here to disable only x axis grids
          },
          categories: ["Jan", "Feb", "Mar", "Apr", "Jun", "Jul", "Aug"],
        },
        grid: {
          show: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0,
            gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
            inverseColors: true,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 50, 80],
            colors: colors,
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      series: [
        {
          name: "total",
          data: [94, 80, 94, 80, 94, 80, 94],
        },
        {
          name: "pipline",
          data: [72, 60, 84, 60, 74, 60, 78],
        },
      ],
    };
    //chart2
    const chart2 = {
      options: {
        colors: colors,
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 10,
              size: "50%",
            },
            track: {
              margin: 10,
              strokeWidth: "50%",
            },
            dataLabels: {
              show: false,
            },
          },
        },
        labels: ["Apples", "Oranges"],
      },
      series: [55, 75],
    };
    const chart3 = {
      options: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: colors,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "28%",
            endingShape: "rounded",
            borderRadius: 5,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["S", "M", "T", "W", "T", "F", "S", "M", "T", "W"],
          labels: {
            minHeight: 20,
            maxHeight: 20,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        yaxis: {
          title: {
            text: "",
          },
          labels: {
            minWidth: 19,
            maxWidth: 19,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      },
      series: [
        {
          name: "Successful deals",
          data: [30, 50, 35, 60, 40, 60, 60, 30, 50, 35],
        },
        {
          name: "Failed deals",
          data: [40, 50, 55, 50, 30, 80, 30, 40, 50, 55],
        },
      ],
    };



    const isIncomingDataEmpty = doughnutIncomingData.datasets[0].data.every(val => val === 0);
    const isOutgoingDataEmpty = doughnutOutgoingData.datasets[0].data.every(val => val === 0);



    return (
      <Fragment>
        <h2 style={{ marginTop: "15px" }}>Analytics Dashboard</h2>
        {(loggedInUserRole && !isCallCenterAgent) && <DashboardUsersCampCount />}
        {(loggedInUserRole && !isCallCenterAgent) && <DashboardCampaignDetails />}
        {(loggedInUserRole && isSuperAdmin) && <PendingPromptsTable />}
        {(loggedInUserRole && isSuperAdmin) && <SystemMonitor />}
        {(loggedInUserRole && (isSuperAdmin || isCallCenterAdmin)) && <AgentBreakExceededList />}
        {(loggedInUserRole && !isCallCenterAgent) && <UserWiseCampaignSummary />}
        {(loggedInUserRole && !isCallCenterAgent) && <TodayRunningCampaigns />}
        {(loggedInUserRole && isCallCenterAgent) && <CTIAgentUI />}
        {(isCallCenterAdmin || isSuperAdmin || isCompanyAdmin || isReseller) ? <>
          <DashboardCallsCharts
            barAgentsData={barAgentsData}
            doughnutData1={doughnutData1}
            barIncomingData={barIncomingData}
            incomingData={incomingData}
            isIncomingDataEmpty={isIncomingDataEmpty}
            barOutgoingData={barOutgoingData}
            outgoingDataDoughnut={outgoingDataDoughnut}
            isOutgoingDataEmpty={isOutgoingDataEmpty}
            startDate={startDate}
            endDate={endDate}
            handleDashboardStartDateChange={handleDashboardStartDateChange}
            handleDashboardEndDateChange={handleDashboardEndDateChange}
            dashboardStartCalendarMinDate={dashboardStartCalendarMinDate}
            dashboardStartCalendarMaxDate={dashboardStartCalendarMaxDate}
            dashboardEndCalendarMinDate={dashboardEndCalendarMinDate}
            dashboardEndCalendarMaxDate={dashboardEndCalendarMaxDate}
            handleFilter={handleFilter}
          />
        </>
          : 
          isCallCenterAgent ? (
  <>
  </>
          )
           :
            <Row xs={1} md={2} lg={5} className="g-3">
              {data.map((item, idx) => (
                <Col key={idx}>
                  <Card
                    className="shadow-sm dashboard-mini-card"
                    style={{
                      borderRadius: '12px',
                      height: '100px',
                      position: 'relative',
                      overflow: 'hidden',
                      marginBottom: "10px",
                      borderBottom: `4px solid ${item.bgColor}`
                    }}
                  >
                    {/* Background Icon */}
                    <div
                      className="dashboard-mini-card__bg-icon"
                      style={{
                        position: 'absolute',
                        top: '50%',
                        right: '1%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '3rem',
                        color: 'rgba(0, 0, 0, 0.1)',
                        zIndex: 0,
                      }}
                    >
                      {item.icon}
                    </div>

                    <Card.Body
                      className="d-flex align-items-center p-2 dashboard-mini-card__body"
                      style={{ position: 'relative', zIndex: 1 }}
                    >
                      {/* Foreground Icon */}
                      <div className="dashboard-mini-card__icon" style={{
                        backgroundColor: item.bgColor,
                        color: "white",
                        borderRadius: "50%",
                        width: "50px",
                        height: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                        flexShrink: 0,
                      }}>
                        {item.icon}
                      </div>

                      {/* Text Content */}
                      <div className="dashboard-mini-card__content" style={{ flexGrow: 1, textAlign: 'center' }}>
                        <Card.Title className="mb-0 dashboard-mini-card__title" style={{ fontSize: '1rem', fontWeight: '600' }}>
                          {item.title}
                        </Card.Title>
                        <Card.Text className="dashboard-mini-card__value" style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                          {item.value}
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
        }

        <Container className="my-4">
          {isCallCenterAgent ?
            (
              <>
                {/* <DashboardButtons /> */}
                {/* <FloatingPanels /> */}
              </>

            ) : (
              <AgentStatusDistribution graphData={graphData} />
            )}

        </Container>
      </Fragment>
    );
  })

  export default Index
